// extracted by mini-css-extract-plugin
export default {"SectionTitle":"meinian-new-order-detail_SectionTitle__MS1bx","SectionSubTitle":"meinian-new-order-detail_SectionSubTitle__M19mH","Toolbar":"meinian-new-order-detail_Toolbar__y9wT4"};